/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypePresentationIcon24Solid = forwardRef('FileTypePresentationIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 9.226a3.774 3.774 0 1 0 3.774 3.779h-3.52a.25.25 0 0 1-.25-.25v-3.53H12Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.201 2.879A3 3 0 0 0 13.08 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V8.92a3 3 0 0 0-.879-2.121l-3.92-3.92ZM6.726 13a5.274 5.274 0 1 1 10.548 0 5.274 5.274 0 0 1-10.548 0Z" })));
});
